import { useState } from "react";

function usePopover() {
    const [popoverMap, setPopoverMap] = useState({});

    const openPopover = (key, event) => {
        setPopoverMap((prev) => ({
            ...prev,
            [key]: { anchorEl: event.currentTarget, open: true },
        }));
    };

    const closePopover = (key) => {
        setPopoverMap((prev) => ({
            ...prev,
            [key]: { anchorEl: null, open: false },
        }));
    };

    const getPopoverProps = (key) => ({
        anchorEl: popoverMap[key]?.anchorEl || null,
        open: popoverMap[key]?.open || false,
        onMouseEnter: (e) => openPopover(key, e),
        onMouseLeave: () => closePopover(key),
    });

    return { getPopoverProps, closePopover };
}

export default usePopover;